export default __webpack_public_path__ + "static/media/eye-off.e66ef2c6.svg";